export const randomHexOfLength = (length: number) => {
  if (window.crypto) {
    const randomValues = window.crypto.getRandomValues(new Uint8Array(Math.ceil(length / 2)))
    const randomHex = randomValues.reduce<string[]>((memo: string[], val) => {
      // vals are generated from 8bit Uints which corresponds to 1-2 characters of hex (0 - ff)
      const eightBitHex = val.toString(16)
      const eightBitHexZeroPadded = `00${eightBitHex}`.slice(1, 3)
      return [...memo, eightBitHexZeroPadded]
    }, [])
    return randomHex.slice(0, length).join('')
  } else {
    // Reference: https://stackoverflow.com/a/19964557
    return (Math.random().toString(16) + '0'.repeat(length + 1)).slice(2, length + 2)
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/utils/random.ts